import { Button, IconButton } from '@mui/material';
import './olivesMobile.css';
import olive1 from "../../../../../assets/olives/olea-tige.webp";
import olive11 from "../../../../../assets/olives/olea-tige-sm.jpeg";
import olive12 from "../../../../../assets/olives/olea-tige-md.jpeg";

import olive2 from "../../../../../assets/olives/olea-bonsaii.webp";
import olive21 from "../../../../../assets/olives/olea-bonsaii-md.jpeg";
import olive22 from "../../../../../assets/olives/olea-bonsaii-l.jpeg";
import olive23 from "../../../../../assets/olives/olea-bonsaii-xl.jpeg";
import olive24 from "../../../../../assets/olives/olea-bonsaii-sm.jpeg";

import olive3 from "../../../../../assets/olives/specimen.jpg";
import specimen1 from "../../../../../assets/olives/specimen1 (1).jpeg";
import specimen2 from "../../../../../assets/olives/specimen1 (2).jpeg";
import specimen3 from "../../../../../assets/olives/specimen1 (3).jpeg";
import specimen4 from "../../../../../assets/olives/specimen1 (4).jpeg";
import specimen5 from "../../../../../assets/olives/specimen1 (5).jpeg";
import specimen6 from "../../../../../assets/olives/specimen1 (6).jpeg";
import specimen7 from "../../../../../assets/olives/specimen1 (7).jpeg";
import specimen8 from "../../../../../assets/olives/specimen1 (8).jpeg";
import specimen9 from "../../../../../assets/olives/specimen1 (9).jpeg";
import specimen10 from "../../../../../assets/olives/specimen1 (10).jpeg";
import specimen11 from "../../../../../assets/olives/specimen1 (11).jpeg";
import specimen12 from "../../../../../assets/olives/specimen1 (12).jpeg";
import specimen13 from "../../../../../assets/olives/specimen1 (13).jpeg";
import specimen14 from "../../../../../assets/olives/specimen1 (14).jpeg";
import specimen15 from "../../../../../assets/olives/specimen1 (15).jpeg";
import specimen16 from "../../../../../assets/olives/specimen1 (16).jpeg";
import specimen17 from "../../../../../assets/olives/specimen1 (17).jpeg";
import specimen18 from "../../../../../assets/olives/specimen1 (18).jpeg";
import specimen19 from "../../../../../assets/olives/specimen1 (19).jpeg";
import specimen20 from "../../../../../assets/olives/specimen1 (20).jpeg";
import specimen21 from "../../../../../assets/olives/specimen1 (21).jpeg";
import arbequina from "../../../../../assets/olives/arbequina.jpg";
import arbequina1 from "../../../../../assets/olives/arbequina1.jpeg";
import arbequina2 from "../../../../../assets/olives/arbequina2.jpeg";
import arbequina3 from "../../../../../assets/olives/arbequina3.jpeg";

import koroneiki from "../../../../../assets/olives/koroneiki.webp";
import koroneiki1 from "../../../../../assets/olives/koroneiki1.jpeg";
import koroneiki2 from "../../../../../assets/olives/koroneiki2.jpeg";

import local from "../../../../../assets/olives/arbequina.jpg";
import local1 from "../../../../../assets/olives/Local-sm.jpeg";
import local2 from "../../../../../assets/olives/Local-md.jpeg";
import local3 from "../../../../../assets/olives/Local-lg.jpeg";
import local4 from "../../../../../assets/olives/Local-xl.jpeg";



import BackIcon from '../../../../../components/back/back';
import { useNavigate } from 'react-router-dom';

type GalleryImage = {
    src: string;
    size?: string;
    name?: string;
};


type OlivesFamily = {
    id: number;
    name: string;
    img: string;
    description: string;
    gallery: GalleryImage[];
};

export const OlivesFamilies: OlivesFamily[] = [
    {
        id: 1,
        name: "Olea Tige",
        img: olive1,
        description: "A tall olive tree with a clean, upright trunk and dense silver-green foliage. Perfect for adding elegance and structure to gardens or entrances.",
        gallery: [
            { src: olive11, size: "small" },
            { src: olive12, size: "medium" },
        ],
    },
    {
        id: 2,
        name: "Olea Bonsaii",
        img: olive2,
        description: "A beautifully crafted bonsai-style olive tree featuring a thick trunk and sculpted branches. Ideal for decorative indoor or outdoor spaces.",
        gallery: [
            { src: olive24, size: "small" },
            { src: olive21, size: "medium" },
            { src: olive22, size: "large" },
            { src: olive23, size: "xl" },
        ],
    },
    {
        id: 3,
        name: "Olea Specimen",
        img: olive3,
        description: "A premium, mature olive tree with unique trunk character and abundant foliage. These specimen trees make exceptional statement pieces for landscapes.",
        gallery: [
            { src: specimen1 },
            { src: specimen2 },
            { src: specimen3 },
            { src: specimen4 },
            { src: specimen5 },
            { src: specimen6 },
            { src: specimen7 },
            { src: specimen8 },
            { src: specimen9 },
            { src: specimen10 },
            { src: specimen11 },
            { src: specimen12 },
            { src: specimen13 },
            { src: specimen14 },
            { src: specimen15 },
            { src: specimen16 },
            { src: specimen17 },
            { src: specimen18 },
            { src: specimen19 },
            { src: specimen20 },
            { src: specimen21 },
        ],
    },
    {
    id: 4,
    name: "Olea Arbequina",
    img: arbequina,
    description: "A compact olive variety known for its dense foliage and graceful shape. Arbequina is highly adaptable, making it ideal for home gardens, patios, and decorative indoor placements.",
    gallery: [
        { src: arbequina1, size: "small" },
        { src: arbequina2, size: "medium" },
        { src: arbequina3, size: "large" },
    ],
},
{
    id: 5,
    name: "Olea Koroneiki",
    img: koroneiki,
    description: "A vigorous Greek olive cultivar with slender leaves and a refined structure. Koroneiki is prized for its resilience and elegant appearance, perfect for both ornamental and productive planting.",
    gallery: [
        { src: koroneiki1, size: "small" },
        { src: koroneiki2, size: "medium" },
    ],
},
{
    id: 6,
    name: "Local Olea",
    img: local,
    description: "A traditional regional olive tree known for its hardy nature and naturally balanced canopy. This variety thrives in Mediterranean climates and brings an authentic, rustic charm to any landscape.",
    gallery: [
        { src: local1, size: "small" },
        { src: local2, size: "medium" },
        { src: local3, size: "large" },
        { src: local4, size: "xl" },
    ],
},

];




export default function OlivesMobile() {
    const navigate = useNavigate();

    const handleClick = (name: any) => {
        navigate(`/olives/${name}`);
    };

    return (
        <div className="ficus-container-mobile">
            <BackIcon />
            <div className="title-overlay" style={{ marginTop: "1rem" }}>
                <h1 className="title-modern-mobile">Olives Collection</h1>
            </div>
            <div className="plants-category-container grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8" >
                {OlivesFamilies.map((olives) => (
                    <div key={olives.id} onClick={() => handleClick(olives.name)} className=" ficus-shape-card bg-white p-6 rounded-xl shadow-lg transform transition-all hover:scale-105">
                        <img
                            src={olives.img}
                            alt={olives.name}
                            className="w-full h-60 object-cover rounded-lg mb-4"
                        />
                        <p className="plant-name">{olives.name}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
